/**
 * Comprehensive mapping of Indian cities by State/UT.
 * Every state's list includes: capital, major cities, tier-2/3 hubs and
 * district headquarters that customers most commonly enter as their
 * mailing city. Total ~530 cities across 36 states/UTs.
 *
 * `OTHER_CITY` is the free-text fallback for smaller towns and villages.
 * When selected, the UI reveals a manual input.
 *
 * State keys MUST match the STATES list rendered by the state dropdown
 * — spelling and casing identical, or the city selector won't populate.
 */
export const OTHER_CITY = "Other (type manually)";

export const CITIES_BY_STATE = {
  "Andhra Pradesh": [
    "Visakhapatnam","Vijayawada","Guntur","Nellore","Kurnool","Rajahmundry","Tirupati","Kadapa","Kakinada","Anantapur",
    "Eluru","Ongole","Chittoor","Machilipatnam","Srikakulam","Vizianagaram","Proddatur","Adoni","Tenali","Nandyal","Amaravati"
  ],
  "Arunachal Pradesh": [
    "Itanagar","Naharlagun","Pasighat","Tawang","Ziro","Bomdila","Tezu","Roing","Along","Khonsa","Namsai","Yingkiong","Anini","Changlang","Seppa"
  ],
  "Assam": [
    "Guwahati","Dibrugarh","Silchar","Jorhat","Nagaon","Tezpur","Tinsukia","Bongaigaon","Karimganj","Sivasagar",
    "Barpeta","Dhubri","Diphu","Goalpara","Golaghat","Hailakandi","Lakhimpur","Morigaon","Nalbari","Sonitpur"
  ],
  "Bihar": [
    "Patna","Gaya","Bhagalpur","Muzaffarpur","Darbhanga","Bihar Sharif","Purnia","Arrah","Begusarai","Katihar",
    "Munger","Chapra","Danapur","Saharsa","Sasaram","Hajipur","Dehri","Siwan","Motihari","Nawada","Bettiah","Buxar","Kishanganj","Jamalpur","Jehanabad"
  ],
  "Chhattisgarh": [
    "Raipur","Bhilai","Bilaspur","Korba","Durg","Rajnandgaon","Raigarh","Jagdalpur","Ambikapur","Dhamtari",
    "Chirmiri","Mahasamund","Kanker","Kawardha","Sakti"
  ],
  "Goa": [
    "Panaji","Margao","Vasco da Gama","Mapusa","Ponda","Bicholim","Curchorem","Sanguem","Canacona","Valpoi","Cuncolim","Quepem"
  ],
  "Gujarat": [
    "Ahmedabad","Surat","Vadodara","Rajkot","Bhavnagar","Jamnagar","Junagadh","Gandhinagar","Anand","Navsari",
    "Morbi","Nadiad","Mehsana","Bharuch","Vapi","Porbandar","Palanpur","Godhra","Valsad","Patan","Veraval","Ankleshwar","Botad","Amreli","Deesa","Dahod","Kalol"
  ],
  "Haryana": [
    "Faridabad","Gurugram","Panipat","Ambala","Yamunanagar","Rohtak","Hisar","Karnal","Sonipat","Panchkula",
    "Bhiwani","Sirsa","Bahadurgarh","Jind","Thanesar","Kaithal","Rewari","Palwal","Fatehabad","Narnaul","Jhajjar","Charkhi Dadri"
  ],
  "Himachal Pradesh": [
    "Shimla","Dharamshala","Solan","Mandi","Kullu","Manali","Palampur","Kangra","Nahan","Una",
    "Bilaspur","Chamba","Hamirpur","Sundernagar","Baddi","Nalagarh","Paonta Sahib","Kasauli","Dalhousie","Kinnaur","Keylong"
  ],
  "Jharkhand": [
    "Ranchi","Jamshedpur","Dhanbad","Bokaro","Hazaribagh","Deoghar","Giridih","Ramgarh","Medininagar","Phusro",
    "Chirkunda","Chaibasa","Dumka","Sahibganj","Jhumri Telaiya","Gumla","Chatra","Godda","Latehar","Simdega"
  ],
  "Karnataka": [
    "Bengaluru","Mysuru","Hubballi","Mangaluru","Belagavi","Kalaburagi","Davangere","Ballari","Tumakuru","Shivamogga",
    "Bidar","Raichur","Vijayapura","Hassan","Udupi","Chikkamagaluru","Mandya","Chitradurga","Kolar","Bagalkot","Karwar","Gadag","Haveri","Chikkaballapur","Yadgir","Koppal","Ramanagara","Robertsonpet","Bhadravati"
  ],
  "Kerala": [
    "Thiruvananthapuram","Kochi","Kozhikode","Kollam","Thrissur","Alappuzha","Palakkad","Kannur","Kottayam","Malappuram",
    "Pathanamthitta","Idukki","Kasaragod","Wayanad","Ernakulam","Guruvayur","Munnar","Varkala","Kalpetta","Perinthalmanna","Manjeri","Tirur","Ponnani","Angamaly","Attingal"
  ],
  "Madhya Pradesh": [
    "Bhopal","Indore","Jabalpur","Gwalior","Ujjain","Sagar","Dewas","Satna","Ratlam","Rewa",
    "Katni","Singrauli","Burhanpur","Khandwa","Morena","Bhind","Chhindwara","Guna","Shivpuri","Vidisha","Chhatarpur","Damoh","Mandsaur","Neemuch","Pithampur","Hoshangabad","Itarsi","Sehore","Betul","Datia","Sidhi","Tikamgarh"
  ],
  "Maharashtra": [
    "Mumbai","Pune","Nagpur","Nashik","Thane","Aurangabad","Solapur","Amravati","Kolhapur","Sangli",
    "Navi Mumbai","Kalyan","Dombivli","Vasai-Virar","Ulhasnagar","Malegaon","Jalgaon","Akola","Latur","Dhule",
    "Ahmednagar","Chandrapur","Parbhani","Jalna","Ichalkaranji","Bhusawal","Nanded","Beed","Yavatmal","Satara","Osmanabad","Ratnagiri","Bhiwandi","Panvel","Wardha","Gondia","Hinganghat","Karad","Baramati","Barshi","Miraj"
  ],
  "Manipur": [
    "Imphal","Thoubal","Bishnupur","Churachandpur","Ukhrul","Senapati","Tamenglong","Chandel","Jiribam","Kakching","Moirang","Mayang Imphal","Nambol","Lilong"
  ],
  "Meghalaya": [
    "Shillong","Tura","Jowai","Nongstoin","Baghmara","Williamnagar","Nongpoh","Mairang","Resubelpara","Cherrapunji","Mawlai"
  ],
  "Mizoram": [
    "Aizawl","Lunglei","Champhai","Serchhip","Kolasib","Saiha","Lawngtlai","Mamit","Bairabi","Khawzawl","Hnahthial"
  ],
  "Nagaland": [
    "Kohima","Dimapur","Mokokchung","Tuensang","Wokha","Mon","Zunheboto","Phek","Kiphire","Longleng","Peren","Chumukedima"
  ],
  "Odisha": [
    "Bhubaneswar","Cuttack","Rourkela","Berhampur","Sambalpur","Puri","Balasore","Bhadrak","Baripada","Jharsuguda",
    "Angul","Kendujhar","Rayagada","Jeypore","Paradip","Dhenkanal","Barbil","Talcher","Sundargarh","Jajpur","Bolangir","Koraput","Nayagarh","Boudh","Nabarangpur"
  ],
  "Punjab": [
    "Ludhiana","Amritsar","Jalandhar","Patiala","Bathinda","Mohali","Hoshiarpur","Pathankot","Moga","Batala",
    "Firozpur","Kapurthala","Sangrur","Malerkotla","Barnala","Rajpura","Khanna","Phagwara","Muktsar","Faridkot","Nawanshahr","Fatehgarh Sahib","Nabha","Mansa","Zirakpur","Anandpur Sahib"
  ],
  "Rajasthan": [
    "Jaipur","Jodhpur","Udaipur","Kota","Bikaner","Ajmer","Bhilwara","Alwar","Sikar","Sri Ganganagar",
    "Bharatpur","Pali","Tonk","Kishangarh","Beawar","Hanumangarh","Dhaulpur","Banswara","Chittorgarh","Churu","Nagaur","Jaisalmer","Barmer","Mount Abu","Pushkar","Sawai Madhopur","Bundi","Jhalawar","Dungarpur","Jhunjhunu","Sirohi"
  ],
  "Sikkim": [
    "Gangtok","Namchi","Gyalshing","Mangan","Rangpo","Singtam","Jorethang","Ravangla","Pelling","Yuksom","Lachung","Lachen"
  ],
  "Tamil Nadu": [
    "Chennai","Coimbatore","Madurai","Tiruchirappalli","Salem","Tirunelveli","Tiruppur","Vellore","Erode","Thoothukudi",
    "Dindigul","Thanjavur","Ranipet","Sivakasi","Karur","Udhagamandalam","Hosur","Nagercoil","Kanchipuram","Kumbakonam",
    "Cuddalore","Kanyakumari","Rameshwaram","Karaikudi","Neyveli","Nagapattinam","Viluppuram","Tiruvannamalai","Pollachi","Rajapalayam","Puducherry","Namakkal","Ambur","Krishnagiri"
  ],
  "Telangana": [
    "Hyderabad","Warangal","Nizamabad","Karimnagar","Ramagundam","Khammam","Mahbubnagar","Nalgonda","Adilabad","Suryapet",
    "Miryalaguda","Jagtial","Mancherial","Nirmal","Kothagudem","Bhadrachalam","Siddipet","Medak","Sangareddy","Vikarabad","Zaheerabad","Wanaparthy","Bodhan"
  ],
  "Tripura": [
    "Agartala","Udaipur","Dharmanagar","Kailashahar","Belonia","Ambassa","Khowai","Sabroom","Sonamura","Melaghar","Teliamura","Amarpur"
  ],
  "Uttar Pradesh": [
    "Lucknow","Kanpur","Ghaziabad","Agra","Meerut","Varanasi","Prayagraj","Bareilly","Aligarh","Moradabad",
    "Saharanpur","Gorakhpur","Noida","Firozabad","Loni","Jhansi","Muzaffarnagar","Mathura","Rampur","Shahjahanpur",
    "Ayodhya","Farrukhabad","Etawah","Mirzapur","Bulandshahr","Sambhal","Amroha","Hardoi","Fatehpur","Raebareli",
    "Orai","Sitapur","Bahraich","Modinagar","Unnao","Jaunpur","Lakhimpur","Hathras","Banda","Pilibhit","Barabanki","Khurja","Gonda","Mainpuri","Etah","Deoria","Ghazipur","Sultanpur","Azamgarh","Bijnor","Sikandrabad","Basti","Chandausi","Akbarpur","Ballia","Tanda","Greater Noida","Shikohabad"
  ],
  "Uttarakhand": [
    "Dehradun","Haridwar","Roorkee","Haldwani","Rudrapur","Kashipur","Rishikesh","Nainital","Pithoragarh","Mussoorie",
    "Ramnagar","Almora","Pauri","Bageshwar","Champawat","Chamoli","Uttarkashi","Tehri","Kotdwar","Kichha","Manglaur","Sitarganj","Srinagar","Joshimath"
  ],
  "West Bengal": [
    "Kolkata","Howrah","Durgapur","Asansol","Siliguri","Bardhaman","Malda","Baharampur","Habra","Kharagpur",
    "Shantipur","Dankuni","Dhulian","Ranaghat","Haldia","Raiganj","Krishnanagar","Nabadwip","Medinipur","Jalpaiguri",
    "Balurghat","Basirhat","Bankura","Chakdaha","Darjeeling","Alipurduar","Purulia","Jangipur","Bolpur","Bangaon","Cooch Behar","Kalimpong","Kalyani"
  ],
  "Andaman & Nicobar": [
    "Port Blair","Diglipur","Mayabunder","Rangat","Havelock","Neil Island","Car Nicobar","Campbell Bay","Hut Bay","Bamboo Flat","Garacharma"
  ],
  "Chandigarh": [
    "Chandigarh","Manimajra","Burail","Dhanas","Hallomajra","Kaimbwala","Kishangarh","Maloya","Palsora","Sarangpur","Khuda Ali Sher"
  ],
  "Dadra & Nagar Haveli and Daman & Diu": [
    "Silvassa","Daman","Diu","Amli","Vapi","Naroli","Dadra","Khanvel","Rakholi","Samarvarni","Masat"
  ],
  "Delhi": [
    "New Delhi","North Delhi","South Delhi","East Delhi","West Delhi","Central Delhi","North East Delhi","North West Delhi","South East Delhi","South West Delhi","Shahdara","Rohini","Dwarka","Karol Bagh","Connaught Place","Chanakyapuri","Saket","Vasant Kunj","Pitampura","Janakpuri","Mayur Vihar","Preet Vihar","Lajpat Nagar","Nehru Place","Rajouri Garden","Malviya Nagar","Munirka","Okhla","Narela","Najafgarh"
  ],
  "Jammu & Kashmir": [
    "Srinagar","Jammu","Anantnag","Baramulla","Kathua","Udhampur","Sopore","Kupwara","Pulwama","Bandipora",
    "Ganderbal","Kulgam","Shopian","Budgam","Doda","Kishtwar","Ramban","Reasi","Rajouri","Poonch","Samba","Katra","Sonamarg","Gulmarg","Pahalgam"
  ],
  "Ladakh": [
    "Leh","Kargil","Nubra","Diskit","Nyoma","Zanskar","Padum","Drass","Khaltse","Turtuk","Chushul"
  ],
  "Lakshadweep": [
    "Kavaratti","Agatti","Amini","Andrott","Kadmat","Kalpeni","Kiltan","Minicoy","Chetlat","Bitra","Bangaram"
  ],
  "Puducherry": [
    "Puducherry","Karaikal","Yanam","Mahe","Ozhukarai","Villianur","Ariyankuppam","Bahour","Nettapakkam","Thirunallar","Mahe Town"
  ],
};

/**
 * Case-insensitive lookup of the cities for a given state.
 * Returns `[]` when the state key is missing so callers can fall back
 * to a free-text input.
 */
export const citiesFor = (stateName) => {
  if (!stateName) return [];
  const key = Object.keys(CITIES_BY_STATE).find(
    (k) => k.toLowerCase() === stateName.toLowerCase()
  );
  return key ? CITIES_BY_STATE[key] : [];
};
